var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIRpe03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_22062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5576 6.36875C28.3916 4.36129 31.0799 3.05404 33.1998 4.73067C35.7597 6.75418 36.1966 11.8162 35.9332 15.1084C35.7372 17.5655 35.2683 19.8813 34.3368 22.1393C32.657 26.2121 29.5222 29.3308 25.382 30.9111C20.4196 32.8094 14.8212 32.7676 9.93261 30.6766C4.55584 28.3737 1.48844 23.5815 0.4285 17.9542C-0.0597131 15.3622 -0.175335 12.799 0.31609 10.2166C0.63086 8.56892 1.12549 7.02398 2.09549 5.69746C3.18755 4.20391 4.9509 3.59686 6.7014 4.19427C9.30627 5.11289 11.1017 7.77879 12.4347 10.313C13.1863 8.46614 14.0664 6.75418 15.4539 5.34736C16.8896 3.89235 19.0448 3.75103 20.5769 5.10646C22.1379 6.39766 23.0758 8.36015 23.9366 10.3002C24.6593 8.84194 25.4751 7.54753 26.5543 6.36554L26.5576 6.36875Z",
    fill: "#E55151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0873 19.7239C25.038 21.4358 24.3924 24.1595 22.8604 24.3201C22.2886 24.3779 21.6623 24.0857 21.3218 23.4786C20.7084 22.393 20.7308 20.8159 21.3218 19.7206C21.6302 19.1489 22.1569 18.8823 22.658 18.8599C23.2201 18.8342 23.7597 19.1361 24.0873 19.7239Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6738 19.6468C15.6888 21.2881 15.0946 24.1563 13.4758 24.3073C12.8687 24.3651 12.2649 23.9957 11.9405 23.3791C10.9737 21.545 11.7381 18.9691 13.1706 18.8599C13.7648 18.8149 14.3109 19.0622 14.6738 19.6468Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0259 27.8244C20.2689 27.8244 21.0333 26.986 20.2914 26.3951C19.7068 25.9325 18.891 25.6435 17.9884 25.6435C17.0859 25.6435 16.3311 25.9101 15.7529 26.3437C14.9532 26.9411 15.6662 27.8212 16.9574 27.8212H19.0259V27.8244Z",
    fill: "#231815",
    stroke: "#231815",
    strokeWidth: 1.6702,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0184 18.7763C33.0622 18.4969 33.695 17.5108 33.634 16.4316C33.6083 15.982 33.4862 15.5387 33.2036 15.0377C32.6832 14.1126 31.9638 13.1908 31.5687 12.2336C31.5077 12.0827 31.286 12.0827 31.2218 12.2336C30.8267 13.1908 30.1073 14.1126 29.5869 15.0377C29.2657 15.6094 29.1533 16.104 29.1533 16.6211C29.1533 18.0601 30.5088 19.181 32.0152 18.7796L32.0184 18.7763Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_22062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRpe03);
export default __webpack_public_path__ + "static/media/i_RPE_03.f8f61e88eeecec753398de94d72b537e.svg";
export { ForwardRef as ReactComponent };